import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/logo-white-no-title.svg';
import './header.css';

const navigation = [
  { label: 'Work', to: '/#work' },
  { label: 'Capabilities', to: '/#capabilities' },
  { label: 'Process', to: '/#process' },
  { label: 'Insights', to: '/blog' },
  { label: 'About', to: '/#about' },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    document.body.classList.toggle('menu-open', open);
    return () => document.body.classList.remove('menu-open');
  }, [open]);

  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <Link className="brand" to="/" aria-label="TryOuts home">
          <img src={logo} alt="" width="36" height="36" />
          <span>TRYOUTS</span>
        </Link>

        <button
          className="menu-toggle"
          type="button"
          aria-expanded={open}
          aria-controls="primary-navigation"
          aria-label={open ? 'Close navigation menu' : 'Open navigation menu'}
          onClick={() => setOpen((value) => !value)}
        >
          <span />
          <span />
        </button>

        <nav
          id="primary-navigation"
          className={`site-nav ${open ? 'site-nav--open' : ''}`}
          aria-label="Primary navigation"
        >
          {navigation.map((item) => (
            <Link key={item.label} className="site-nav__link" to={item.to}>
              {item.label}
            </Link>
          ))}
          <Link className="button button--primary site-nav__cta" to="/contact">
            Start a project <span aria-hidden="true">↗</span>
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
